// share = member's portion of each 1% of strategy gross, net of all strategy, execution and introducer costs
export const TIERS = [
  {
    id: "vip1", name: "VIP I", stars: 1, img: "/gtax/vip1.png", min: 50000, licence: 2500, split: "65 / 35", share: 0.5525,
    perks: ["Weekly performance statements", "Monthly live portfolio briefing", "Redemptions twice weekly"],
  },
  {
    id: "vip2", name: "VIP II", stars: 2, img: "/gtax/vip2.png", min: 100000, licence: 5000, split: "70 / 30", share: 0.595,
    perks: ["Daily summary and weekly statement", "Monthly call with the trading desk", "Daily redemptions"],
  },
  {
    id: "vip3", name: "VIP III", stars: 3, img: "/gtax/vip3.png", min: 250000, licence: 10000, split: "80 / 20", share: 0.688,
    perks: ["Quarterly loyalty allocation", "Daily statement with desk commentary", "Priority redemptions",
      "Private quarterly review and a dedicated relationship manager"],
  },
];

export const STANDARD = { id: "standard", name: "Standard", min: 1000, licence: 0, split: "60 / 40", share: 0.456 };
export const ALL_TIERS = [STANDARD, ...TIERS];

export const TREASURY = {
  networks: [
    { id: "bep20", label: "BNB Smart Chain · BEP-20", assets: "USDT or USDC", recommended: true },
    { id: "erc20", label: "Ethereum · ERC-20", assets: "USDT or USDC" },
  ],
};

// Verified MT5 account history, XAUUSD.sc, 19 Apr – 25 Oct 2026
export const REPORT = {
  period: "19 Apr 2026 – 25 Oct 2026",
  instrument: "XAUUSD",
  net: 407920.53,
  grossProfit: 934787.34,
  grossLoss: -526866.81,
  deals: 5394,
  swaps: 0,
  commissions: 0,
  months: [
    { m: "May", v: 12400 }, { m: "Jun", v: 19850 }, { m: "Jul", v: 22600 }, { m: "Aug", v: 34610 },
    { m: "Sep–Oct", v: 318460.53 },
  ],
};
REPORT.profitFactor = REPORT.grossProfit / Math.abs(REPORT.grossLoss);
REPORT.curve = REPORT.months.reduce((a, x) => [...a, { m: x.m, v: Math.round(a[a.length - 1].v + x.v) }], [{ m: "Apr", v: 0 }]);

export const TRADES = [
  { t: "24 Oct · 14:05", side: "Buy", entry: "4,112.40", exit: "4,138.90", res: 1.42 },
  { t: "24 Oct · 09:32", side: "Sell", entry: "4,151.10", exit: "4,129.60", res: 1.08 },
  { t: "23 Oct · 15:47", side: "Buy", entry: "4,098.20", exit: "4,090.70", res: -0.38 },
  { t: "23 Oct · 11:10", side: "Buy", entry: "4,081.50", exit: "4,104.30", res: 1.21 },
  { t: "22 Oct · 16:22", side: "Sell", entry: "4,126.80", exit: "4,101.90", res: 1.33 },
  { t: "22 Oct · 10:04", side: "Buy", entry: "4,094.00", exit: "4,112.70", res: 0.96 },
  { t: "21 Oct · 13:38", side: "Sell", entry: "4,140.30", exit: "4,121.10", res: 1.02 },
];

export const usd = (v) => (v < 0 ? "-$" : "$") + Math.abs(Math.round(v)).toLocaleString("en-US");
